
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(data=null) {
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/optometry-records?${queryString}`; 
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/optometry-records/${id}`, { headers: authHeader() });
    },
    createData(data) {
        let userId = JSON.parse(localStorage.getItem('user'));
        if (!userId || !userId.id) {
            throw new Error("User ID no válido. Asegúrate de haber iniciado sesión.");
        }
        data.user_id = userId.id;
        return axios.post(`${API_URL}/optometry-records`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/optometry-records/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/optometry-records/${id}`, { headers: authHeader() });
    },
    getPdf(id) {
        return axios.get(`${API_URL}/optometry-records/export-cita/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
};